import { z } from "zod";

export const GedDocumentoSchema = z.object({
  statusArquivo: z.coerce.number({ required_error: 'Este campo é obrigatorio!', invalid_type_error: 'Este campo é obrigatorio!' }).default(1),
  arquivo: z.string({ required_error: 'Este campo é obrigatorio!' }).nonempty('Este campo é obrigatorio!'),
  versao: z.string().nullable().default(null),
  centroCusto: z.coerce.number().nullable().default(null),
  conferirAtualizacao: z.coerce.date().nullable().default(null),
  local1: z.string().nullable().default(null),
  local2: z.string().nullable().default(null),
  assunto: z.string().nullable().default(null),
  ondeConsultar: z.string().nullable().default(null),
  dataVencimento: z.coerce.date().nullable().default(null),
  dataPublicacao: z.coerce.date().nullable().default(null),
  dataVigencia: z.coerce.date().nullable().default(null),
  file: z.instanceof(File).nullable().default(null),
  filePdf: z.instanceof(File).nullable().default(null),
  limparArquivo: z.coerce.boolean().default(false),
  limparArquivoPdf: z.coerce.boolean().default(false),
});


export type GedDocumentoForm = z.infer<typeof GedDocumentoSchema>;